import { format } from "date-fns";
import BaseCellRenderer, { IBaseCellRendererParams } from "./BaseCellRenderer";

export default function DateCellRenderer(props: IBaseCellRendererParams<Date>) {
   
    const showDate: Date = new Date(props.value);
    return (
        <BaseCellRenderer {...props}>
            {props.value != null && <>{format(showDate, "dd/MM/yyyy HH:mm:ss")}</>}
        </BaseCellRenderer>
    );
}